import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-07738651"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createTextVNode("上传文件");

const _hoisted_2 = {
  key: 0,
  class: "img-dialog"
};
const _hoisted_3 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Plus = _resolveComponent("Plus");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_upload = _resolveComponent("el-upload");

  const _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_upload, {
    action: $setup.api,
    ref: "upload",
    "list-type": $setup.listType,
    "on-preview": $setup.handlePictureCardPreview,
    "on-remove": $setup.handleRemove,
    "file-list": $setup.fileList,
    "on-exceed": $setup.handleExceed,
    "on-success": $setup.uploadSuccess,
    name: "fileUploads",
    "auto-upload": "",
    limit: $setup.limit,
    disabled: Boolean($setup.imgDisabled),
    class: _normalizeClass({
      'disabled': $setup.imgDisabled || $setup.fileList?.length == $setup.limit || $setup.uploadFile?.length == $setup.limit,
      'file-import': $setup.listType !== 'picture-card'
    })
  }, {
    default: _withCtx(() => [$setup.listType === 'picture-card' ? (_openBlock(), _createBlock(_component_el_icon, {
      key: 0
    }, {
      default: _withCtx(() => [_createVNode(_component_Plus)]),
      _: 1
    })) : (_openBlock(), _createBlock(_component_el_button, {
      key: 1,
      type: "primary",
      disabled: $setup.imgDisabled
    }, {
      default: _withCtx(() => [_hoisted_1]),
      _: 1
    }, 8, ["disabled"]))]),
    _: 1
  }, 8, ["action", "list-type", "on-preview", "on-remove", "file-list", "on-exceed", "on-success", "limit", "disabled", "class"]), $setup.listType === 'picture-card' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_dialog, {
    modelValue: $setup.dialogVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.dialogVisible = $event),
    width: "30%"
  }, {
    default: _withCtx(() => [_createElementVNode("img", {
      "w-full": "",
      src: $setup.dialogImageUrl,
      alt: "图片预览"
    }, null, 8, _hoisted_3)]),
    _: 1
  }, 8, ["modelValue"])])) : _createCommentVNode("", true)]);
}